import request from "helpers/api_helper";
import { jsonToFormData } from "../formData";


export const login = async (reqData) => {
  const formData = jsonToFormData(reqData);
  try {
      const args = {
        url: "login",
        method: "POST",
        body: formData,
      };
      const response = await request(args);
      const data = await response;
      return data;
    } catch (error: any) {
      return error;
    }
};

export const logout = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "logout",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    const data = await response;
    return data;
  } catch (error: any) {
    return error;
  }
};

export const getCurrentUser = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "user",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    const data = await response;
    return {success:true, data};
  } catch (error: any) {
    return {success:true, ...error};
  }
};

export const forgetPassword = async (reqData) => {
  try {
    const args = {
      url: "password/forgotPassword",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reqData),
    };
    const response = await request(args);
    const data = await response;
    // if (data?.success) {
    //   toast.success(data.message);
    // }
    return data;
  } catch (error: any) {
    // toast.error(error.message);
    return error;
  }
}

export const resetPassword = async (reqData) => {
  try {
    const args = {
      url: "password/resetPassword",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reqData),
    };
    const response = await request(args);
    const data = await response;
    // if (data?.success) {
    //   toast.success(data.message);
    // }
    return data;
  } catch (error: any) {
    // toast.error(error.message);
    return error;
  }
}
